import {
  validateDisclaimer,
  
  validateName,
  validate500TextArea,
  validatelMobileNo,
  validateDpiitNumber,
} from "../../common/dependencies/utils/validation";

export default {
  validateStep1: (params) => {
    const { startup_name,startup_enrolmentid, applyto_cohort, disclaimer } = params;
    let formStatus = {};
    const startup_nameStatus = validateName(
      startup_name,
      "Please Enter Startup Name"
    );
    const startup_enrolmentidStatus = validatelMobileNo(
      startup_enrolmentid,
      "Please Enter Startup Enrolment Id"
    );
    const applyto_cohortStatus = validate500TextArea(
      applyto_cohort,
      "*Please Enter Why Do You Want To Apply To This Cohort"
    );
    const disclaimerStatus = validateDisclaimer(disclaimer);

    formStatus = {
      startup_name: startup_nameStatus.error,
      startup_enrolmentid: startup_enrolmentidStatus.error,
      applyto_cohort: applyto_cohortStatus.error,
      disclaimer: disclaimerStatus.error,
      hasErrors:
      startup_nameStatus.hasError || 
      startup_enrolmentidStatus.hasError || 
      applyto_cohortStatus.hasError || 
       disclaimerStatus.hasError,
    };
    
    return formStatus;
  },

}